import { PositionType, PositionTimeUnit } from '@annunciate/core';
export const getProgressTime = (progress, toUnit = PositionTimeUnit.SECONDS) => {
    const position = progress?.position;
    if (position) {
        return getPositionTime(position, toUnit);
    }
    else {
        return 0;
    }
};
export const getPositionTime = (position, toUnit = PositionTimeUnit.SECONDS) => {
    switch (position?.type) {
        case PositionType.TIME:
            const { unit, value } = position;
            switch (unit) {
                case PositionTimeUnit.MINUTES:
                    if (toUnit === PositionTimeUnit.SECONDS) {
                        return 60 * value;
                    }
                    else {
                        return value;
                    }
                case PositionTimeUnit.SECONDS:
                    if (toUnit === PositionTimeUnit.SECONDS) {
                        return value;
                    }
                    else {
                        return value / 60;
                    }
                default:
                    return 0;
            }
        default:
            return 0;
    }
};
//# sourceMappingURL=getPositionTime.js.map